var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import React from 'react';
import { IntlProvider } from 'react-intl';
import { ApolloProvider, Auth0WrapperProvider, AuthenticationProvider, AuthModalProvider, CookieProvider, EnvironmentProvider, EventsProvider, FeaturesProvider, } from '../../components/providers';
import { DefaultThemeProvider } from '../../themes';
import { MockedApolloProvider } from '../apollo';
import { CSPProvider } from './CSPProvider';
export var Providers = function (props) {
    var providers = [];
    var propNames = Object.keys(props);
    propNames.forEach(function (name) {
        switch (name) {
            case 'auth0ProviderProps':
                providers.push([Auth0WrapperProvider, props.auth0ProviderProps]);
                break;
            case 'apolloProviderProps':
                providers.push([ApolloProvider, props.apolloProviderProps]);
                break;
            case 'authenticationProviderProps':
                providers.push([AuthenticationProvider, props.authenticationProviderProps]);
                break;
            case 'authModalProviderProps':
                providers.push([AuthModalProvider, props.authModalProviderProps]);
                break;
            case 'cookieProviderProps':
                providers.push([CookieProvider, props.cookieProviderProps]);
                break;
            case 'cspProviderProps':
                providers.push([CSPProvider, props.cspProviderProps]);
                break;
            case 'defaultThemeProviderProps':
                providers.push(DefaultThemeProvider);
                break;
            case 'environmentProviderProps':
                providers.push([EnvironmentProvider, props.environmentProviderProps]);
                break;
            case 'eventsProviderProps':
                providers.push([EventsProvider, props.eventsProviderProps]);
                break;
            case 'featureProviderProps':
                providers.push([FeaturesProvider, props.featureProviderProps]);
                break;
            case 'intlProviderProps':
                providers.push([IntlProvider, props.intlProviderProps]);
                break;
            case 'mockedApolloProviderProps':
                providers.push([MockedApolloProvider, props.mockedApolloProviderProps]);
                break;
        }
    });
    return providers.reduceRight(function (acc, prov) {
        var Provider = prov;
        if (Array.isArray(prov)) {
            Provider = prov[0];
            return React.createElement(Provider, __assign({}, prov[1]), acc);
        }
        return React.createElement(Provider, null, acc);
    }, props.children);
};
//# sourceMappingURL=Providers.js.map